<template>
    <div
        class="share"
        @click="clickShare">
        <img alt="" class="share-icon" src="./assets/share-icon.png" />
        <span class="share-tip" role="button">{{ i18n('嗌好友一齊免費拎券') }}</span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { i18n } from '../../i18n';

export default defineComponent({
  name: 'CouponShare',
  emits: ['click'],
  setup(props, { emit }) {
    function clickShare() {
      emit('click');
    }
    return {
      clickShare,
      i18n,
    };
  },
});
</script>

<style lang="less" scoped>
@import '../../less/main.less';

.share {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    &-icon {
        display: inline-block;
        width: 40/@rem;
        height: 40/@rem;
    }
    &-tip {
        margin-left: 4/@rem;
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 28/@rem;
        line-height: 40/@rem;
        color: #576B95;
    }
    &:active {
        opacity: 0.5;
    }
}
</style>
